<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tra cứu, tìm kiếm đơn vị</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <sync-data-source :cached="true" v-model="searchForm.syncSourceType" :excluded="[2]" allowClear="true"></sync-data-source>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Đơn vị cấp trên:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree :cached="true" v-model="searchForm.parentId" :syncSourceType="searchForm.syncSourceType" ref="unitTree"></unit-tree>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Trạng thái mã QHNS:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-radio-group v-model="searchForm.hasNationalBudgetCode">
                                        <b-form-radio value="">Tất cả</b-form-radio>
                                        <b-form-radio :value="false">Chưa cập nhật</b-form-radio>
                                        <b-form-radio :value="true">Đã cập nhật</b-form-radio>
                                    </b-form-radio-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Mã đơn vị/Mã QHNS:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input v-model="searchForm.code"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Tên đơn vị:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input v-model="searchForm.name"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Cấp hành chính:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-model="searchForm.administrativeLevel" :options="administrativeLevels"
                                             style="width:100%"
                                             allowClear
                                             placeholder="--- Tất cả ---"></select2>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Cấp đơn vị:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-model="searchForm.unitLevelIds" :options="unitLevels"
                                             style="width:100%"
                                             multiple
                                             placeholder="--- Tất cả ---"></select2>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Loại đơn vị:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <treeselect ref="unitTypeTree"
                                                v-model="searchForm.unitTypeIds"
                                                :defaultExpandLevel="1"
                                                multiple
                                                :append-to-body="true"
                                                :max-height="360"
                                                placeholder="--- Tất cả ---"
                                                :options="unitTypeTree" style="margin-top:1px;" />
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Loại hình đơn vị:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-model="searchForm.functionalUnitType" :options="listFunctionalUnitTypes"
                                             style="width:100%"
                                             allowClear
                                             placeholder="--- Tất cả ---"></select2>
                                </b-form-group>
                            </b-col>
                            <!--<b-col sm="6">
                                <b-form-group label="Địa bàn:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <region-tree v-model="searchForm.regionId"
                                                 ref="regionTree"></region-tree>
                                </b-form-group>
                            </b-col>-->
                            <!--<b-col sm="6">
                                <b-form-group label="Trạng thái hoạt động:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-model="searchForm.isActive" :options="statuses"
                                             style="width:100%"
                                             placeholder="--- Tất cả ---"></select2>
                                </b-form-group>
                            </b-col>-->
                        </b-row>
                        <b-row class="justify-content-sm-center">
                            <b-col sm="6">
                                <b-form-group label="" :label-cols="4">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid-tree :searchForm="searchForm"
                                 :gridOptions="gridOptions"
                                 dataUrl="master-data/units"
                                 gridName="Danh sách đơn vị"
                                 ref="unitTable">
                        <template v-slot:actions>
                            <b-button size="md" @click.stop="exportExcel" variant="secondary">
                                Xuất Excel
                            </b-button>
                            <template v-if="authorize(['ManageUnit']) && isBTCUser">
                                <router-link to="./create" tag="button" class="btn btn-primary" size="md">
                                    Thêm mới
                                </router-link>
                                <!--<b-button size="md" @click.stop="deletes" variant="danger" :disabled="isShowBtnDelete">
                                    Xóa
                                </b-button>-->
                            </template>
                        </template>
                        <template v-slot:cell(syncSourceType)="row">
                            {{ $store.getters.getSyncSourceType(row.value) }}
                        </template>
                        <template v-slot:cell(administrativeLevel)="row">
                            {{ $store.getters.getReportConstant(row.value, 'administrativeLevels') }}
                        </template>
                        <template v-slot:cell(functionalUnitType)="row">
                            {{ row.item.functionalUnitTypeName }}
                        </template>
                        <template v-slot:cell(isActive)="row">
                            <b-form-checkbox v-model="row.value" disabled></b-form-checkbox>
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <template v-if="authorize(['ViewUnit'])">
                                    <b-button size="sm" :to="{ path: `./${row.item.id}`}" title="xem" variant="info">
                                        Xem
                                    </b-button>
                                </template>
                                <template v-if="authorize(['ManageUnit']) && isBTCUser">
                                    <b-button size="sm" :to="{ path: `./${row.item.id}/edit` }" title="sửa" variant="primary">
                                        Sửa
                                    </b-button>
                                    <b-button v-if="authorize(['ManageUnit'])" size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                        Xoá
                                    </b-button>
                                </template>
                            </b-button-group>
                        </template>
                    </b-grid-tree>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'ListUnit',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    code: null,
                    name: null,
                    regionId: null,
                    parentId: null,
                    unitTypeIds: [],
                    functionalUnitType: null,
                    unitLevelIds: [],
                    administrativeLevel: null,
                    isActive: null,
                    syncSourceType: this.getSyncSourceTypeCache(null, [2]),
                    parentId: null,
                    hasNationalBudgetCode: this.$route.query.hasNBC == "false" ? false : null
                },
                statuses: [{ id: true, text: 'Đang hoạt động' }, { id: false, text: 'Ngừng hoạt động' }],
                listFunctionalUnitTypes: [
                    { text: 'Đơn vị tổng hợp', id: 1 },
                    { text: 'Đơn vị đăng ký', id: 2 }
                ],
                gridOptions: {
                    fields: [
                        { key: 'code', label: 'Mã đơn vị', sortable: true, sortDirection: 'asc' },
                        { key: 'nationalBudgetCode', label: 'Mã QHNS', sortable: true, sortDirection: 'asc' },
                        { key: 'name', label: 'Tên đơn vị', sortable: true, tdAttr: (key, value, item) => ({ title: item.unitFullName }) },
                        //{ key: 'regionName', label: 'Tên địa bàn', sortable: true },
                        { key: 'parentUnitName', label: 'Tên đơn vị cấp trên', sortable: true },
                        { key: 'unitTypeName', label: 'Loại đơn vị', sortable: true },
                        { key: 'functionalUnitType', label: 'Loại hình đơn vị', sortable: true },
                        { key: 'unitLevelName', label: 'Cấp đơn vị', sortable: true },
                        { key: 'administrativeLevel', label: 'Cấp hành chính', sortable: true },
                        { key: 'syncSourceType', label: 'Phần mềm đồng bộ', sortable: true },
                        //{ key: 'isActive', label: 'Đang hoạt động', sortable: true }
                    ],
                    sortBy: 'code'
                },
                isShowBtnDelete: true
            }
        },
        computed: {
            ...mapState({
                administrativeLevels: (state, getters) => (state.common.reportConstants.administrativeLevels ?? []).filter(x => x.id <= 2),
                unitLevels: function (state) {
                    return this.searchForm.administrativeLevel == null ? state.common.unitLevels : this.searchForm.administrativeLevel == 1 ? state.common.unitLevelsCentral : state.common.unitLevelsLocal;
                },
                unitTypeTree: (state, getters) => getters.unitTypeTree,
                listAccountingStandard: (state, getters) => state.common.listAccountingStandard
            }),
        },
        created() {
        },
        mounted() {
            //this.$watch(
            //    () => {
            //        return this.$refs.unitTable.selectedRows
            //    },
            //    (val) => {
            //        this.isShowBtnDelete = val.length == 0;
            //    }
            //)
        },
        methods: {
            search() {
                this.$refs.unitTable.refresh();
            },
            exportExcel() {
                this.$services.download('master-data/units/excel');
            },
            remove(item, index, button) {
                var vm = this;

                if (confirm('Bạn có chắc chắn muốn xóa đơn vị này?')) {
                    this.$services.delete(`master-data/units/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa đơn vị thành công');
                        vm.search();
                    });
                }
            },
            deletes() {
                var vm = this;
                var selectedRows = this.$refs.unitTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các đơn vị này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`master-data/units?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa đơn vị thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn đơn vị cần xóa');
                }
            }
        }
    }
</script>
<style scoped>
</style>
